import {Injectable} from '@angular/core';
import {WindowRefService} from './../window-ref.service';
import {ApiService} from './api.service';
import {HttpParams} from '@angular/common/http';
import { TrackingService } from './tracking.service';

const routes = {
    percenete: '/percente',
};

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {

    constructor(private apiService: ApiService, private winRef: WindowRefService,private TrackingService:TrackingService) {}

    public changeCurrecny(value,untrackIt?): Promise<any> {
        !untrackIt ? this.TrackingService.changeDevise() : null;
        let params = new HttpParams({
            fromObject: {
                currency: value,
                idetab : this.winRef.appConfigSite.idEtab.toString(),
            }
        });
        let ob = this.apiService.get(routes.percenete, params);
        let promise = ob.toPromise();
        promise.then((response) => {
            this.winRef.appConfigSite.Ccurrency = value;
            this.winRef.appConfigSite.Cpercente = response.percente;
        });
        return promise;
    }
}
